import { FC } from 'react';
import { ClassicButton, Modal, VARIANT } from 'components';
import styled from 'styled-components';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { ErrorIcon } from 'assets/icons';
import { closeModal } from 'store/modalSlice';

const ModalHeading = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  padding: 0 1.5rem;
  svg {
    margin-left: 0.5rem;
  }
  margin-bottom: 1rem;
`;

const DeletionErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 2.5rem 3.125rem;
  overflow: hidden;
  height: calc(100% - 8rem);
`;

const ErrorsCoontainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
  margin-bottom: 1rem;
`;

const ModalParagraph = styled.p`
  font-size: 1.5rem;
  font-weight: 500;
  text-align: center;
  margin-bottom: 1.5rem;
  white-space: pre-wrap;
`;

const externalContentStyles = {
  height: '40rem',
  width: '56.25rem',
  padding: '0',
  overflow: 'hidden',
};

export const DeletionErrorModal: FC = () => {
  const { props } = useAppSelector(({ modalReducer }) => modalReducer.deletionErrorModal);
  const dispatch = useAppDispatch();

  return (
    <Modal
      modalId="deletionErrorModal"
      externalContentStyles={externalContentStyles}
      headerType="error"
    >
      <DeletionErrorContainer>
        <ModalHeading>
          Error
          <ErrorIcon />
        </ModalHeading>
        <ErrorsCoontainer>
          {props?.errors ? (
            props.errors.map((error, index) => (
              <ModalParagraph key={`${error.code}_${index}`}>{error.message}</ModalParagraph>
            ))
          ) : (
            <ModalParagraph>
              From unknown reason this property could not be deleted, please contact our support
            </ModalParagraph>
          )}
        </ErrorsCoontainer>
        <ClassicButton
          variant={VARIANT.BLACK}
          onClick={() => dispatch(closeModal({ modalId: 'deletionErrorModal' }))}
          width="15rem"
        >
          Close
        </ClassicButton>
      </DeletionErrorContainer>
    </Modal>
  );
};
